export const DOMAIN_NAME = 'https://shop.boscoapteka.ru'

export const ROUTE: Record<string, string> = {
  PROFILE: '/profile',
  USER_ORDERS: '/profile/orders',
  CART: '/cart',
  USER_FAVOURITES: '/profile/favourites',
}
